import { connect } from 'react-redux';
import AbsenceEditSidepanel from '../../components/absence/absence-edit-sidepanel';
import {
  fetchAbsence,
  updateAbsence,
  addAbsence,
  fetchAbsenceSuccess,
  updateAbsenceId,
  updateProgressIndicator,
} from './absence-actions';

const mapStateToProps = state => ({
  absence: state.absence.absence,
  isLoadingAbsenceData: state.absence.isLoadingAbsenceData,
  saveSuccess: state.absence.saveSuccess,
  addSuccess: state.absence.addSuccess,
  plants: state.absence.plants,
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
  serviceCenters: state.user.serviceCenters,
  isLoading: state.absence.isLoading,
  isPolling: state.currentStatus.shouldPoll,
  error: state.absence.error,
});

const mapDispatchToProps = {
  fetchAbsence,
  updateAbsence,
  addAbsence,
  fetchAbsenceSuccess,
  updateAbsenceId,
  updateProgressIndicator,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbsenceEditSidepanel);
